/**
 *
 * 异步加载script
 * @param {string} url   script src路径
 * @param {string} isAsync=true 是否同步加载
 * @param {string} isHeadAppend=false  是否在 document head 添加
 * @returns {promise}
 */
export function asyncLoadScript(url, isAsync, isHeadAppend) {
    if (isAsync === void 0) { isAsync = true; }
    if (isHeadAppend === void 0) { isHeadAppend = false; }
    return new Promise(function (resolve, reject) {
        // 如果已经添加过该地址，则不再添加 直接返回
        var scripts = Array.from(document.getElementsByTagName('script'));
        var finds = scripts.filter(function (item) { return item.src === url; });
        if (finds && finds.length > 0) {
            return resolve(null);
        }
        var script = document.createElement('script');
        script.type = 'text/javascript';
        if (script.readyState) {
            //IE
            script.onreadystatechange = function () {
                if (script.readyState == 'loaded' || script.readyState == 'complete') {
                    script.onreadystatechange = null;
                    resolve(null);
                }
            };
        }
        else {
            //Others: Firefox, Safari, Chrome, and Opera
            script.onload = function () {
                resolve(null);
            };
            script.onerror = function () {
                reject();
            };
        }
        script.src = url;
        if (isAsync) {
            script.async = 1;
        }
        if (isHeadAppend) {
            document.head.appendChild(script);
        }
        else {
            document.body.appendChild(script);
        }
    });
}
/**
 *
 * 异步加载 style
 * @returns {link}
 */
export function asyncLoadStyle(url) {
    var stylesheet = document.createElement('link');
    stylesheet.rel = 'stylesheet';
    stylesheet.href = url;
    document.head.appendChild(stylesheet);
    return stylesheet;
}
/**
 * 获取元素距离顶部距离
 * @param el
 */
export function getElementOffsetTop(el) {
    return (el.offsetTop +
        (el.offsetParent ? getElementOffsetTop(el.offsetParent) : 0));
}
/**
 * 获取元素距离左侧距离
 * @param el
 */
export function getElementOffsetLeft(el) {
    return (el.offsetLeft +
        (el.offsetParent ? getElementOffsetLeft(el.offsetParent) : 0));
}
/**
 * 禁用双指缩放
 */
export function disableViewPortZoom() {
    /*===================== 禁止双指缩放 ====================*/
    document.documentElement.addEventListener('touchstart', function (event) {
        if (event.touches.length > 1) {
            event.preventDefault();
        }
    }, false);
    /*===================== 禁止双击缩放 ====================*/
    var lastTouchEnd = 0;
    document.documentElement.addEventListener('touchend', function (event) {
        var now = Date.now();
        if (now - lastTouchEnd <= 300) {
            event.preventDefault();
        }
        lastTouchEnd = now;
    }, false);
}
